<div class="flex-centered col-xl-4 col-lg-6 col-md-8 col-sm-12 mt-5">
  <h2 class="title">404 Page Not Found</h2>
  <small class="sub-title">The page you were looking for doesn't exist</small>
</div>
